import React,{useEffect} from 'react'

import "./Iqac_blocks.css"

import { Floatinmenu,Underline } from '../../widgets'

import { Timeline } from "../../components";

import { iqac_blocks,iqac_floater_menu } from "../../constants/iqac"


const Iqac_blocks = () => {
  useEffect(() => {
    document.title = 'ACCET-IQAC | Block Grant Audit Statements';
  }, []);
  return (
    <div className='iqac_min_whole_blocks'>

      <Floatinmenu head={iqac_floater_menu.head}  links={iqac_floater_menu.links}/>

      <Underline heading="Block Grant Audit Statements" />


      {iqac_blocks.map((item) => (
      <Timeline
                key={item.id}
                head={item.head}
                house={item.house}
                pdf={item.pdf}
              />
              ))}
    </div>
  )
}

export default Iqac_blocks